
import { defineComponent } from "vue";
import LayoutComponent from "./component.vue";
import { StartDrag } from "@/utils/LayoutHelper";
import { useLayoutStore } from "@/stores/layoutStore";
import Handle from "./handle.vue";
export default defineComponent({
	setup() {
		const layoutStore = useLayoutStore();
		return { layoutStore };
	},
	name: "StackContainer",
	data() {
		return {
			activeTab: 0,
			uid: this.$uuid4()
		};
	},
	beforeCreate() {
		// this.uid = this.$uuid4();
	},
	mounted() {
		(this.$refs[this.uid] as HTMLElement).style.flexDirection = this.type;
	},
	props: {
		children: {
			type: Array as () => Array<LayoutType>,
			default: () => []
		},
		componentName: {
			type: String,
			default: ""
		},
		id: {
			type: Number,
			default: null
		},
		type: {
			type: String,
			default: ""
		},
		component: {
			type: String,
			default: "LayoutComponent"
		},
		componentState: {
			type: Object as () => ComponentStateType,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		}
	},
	methods: {
		moveComponent(payload: { type: string; id: number; dropEl: number }) {
			this.layoutStore.MOVE_COMPONENT(payload);
		},
		removeComponent(payload: { id: number }) {
			this.layoutStore.REMOVE_COMPONENT(payload);
		},
		dragStart(e: MouseEvent, id: number) {
			this.layoutStore.SET_IS_DRAGGING(true);
			const TIMEOUT = setTimeout(async () => {
				const ROOT_EL = this.$root;
				if (ROOT_EL == null) return;
				const R_EL: any = document.getElementById("app");
				const RESPONSE: { type: string; id: number; dropEl: number } = await StartDrag(
					e,
					id,
					this.$el,
					R_EL
				);
				this.moveComponent(RESPONSE);
			}, 500);
			const MOUSE_UP_LISTENER = () => {
				this.layoutStore.SET_IS_DRAGGING(false);
				clearTimeout(TIMEOUT);
				removeEventListener("mouseup", MOUSE_UP_LISTENER);
			};
			addEventListener("mouseup", MOUSE_UP_LISTENER);
		}
	},
	computed: {
		panelLayout() {
			return this.layoutStore.panelLayout;
		},
		stacked() {
			return this.type == "stacked";
		}
	},
	watch: {
		panelLayout: {
			deep: true,
			handler() {
				this.$nextTick(() => {
					if (this.activeTab > this.children.length - 1) {
						this.activeTab = this.children.length - 1;
					}
				});
			}
		}
	},
	components: {
		LayoutComponent,
		Handle
	}
});
